export default {
  name: "bmodal",
  components: {},
  props: ["value", "hideClose", "title"],
  data() {
    return {};
  },
  computed: {},
  watch: {},
  async mounted() {},
  beforeDestroy() {},
  methods: {
    Hide() {
      this.$emit("input", !this.value);
      this.$emit("hide");
    }
  }
};
